import { Site } from '../modules/site/types';
import ACTIONS, { FETCH_STATUS, NOTIFICATION_TYPE } from '../app.constants';
import { NotificationType } from '../modules/site/types';

export const getSite = {
    pending: {
        type: ACTIONS.GET_SITE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Site) => ({
        type: ACTIONS.GET_SITE.SUCCESS,
        data,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_SITE.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const setSuccess = (data: NotificationType) => {
    return {
        type: ACTIONS.SET_NOTIFICATION,
        data: data,
        notificationType: NOTIFICATION_TYPE.success,
    };
};

export const setError = (data: NotificationType) => {
    return {
        type: ACTIONS.SET_NOTIFICATION,
        data: data,
        notificationType: NOTIFICATION_TYPE.error,
    };
};
